import { Component, OnInit, Input } from '@angular/core';

import { InjectionDataRecord } from '../_models/injection-data-record';
import { InjectionDataBatch } from '../_models/injection-data-batch';

import { UserWellsService } from '../user-wells.service';

import { WellDetailsModel } from '../_models/well-details-model';

@Component({
  selector: 'app-injection-presubmit-data-table',
  templateUrl: './injection-presubmit-data-table.component.html',
  styleUrls: ['./injection-presubmit-data-table.component.css']
})
export class InjectionPresubmitDataTableComponent implements OnInit {

  public displayedColumns = [
    "InjectionDate",
    "VolumeInjectedBbl",
    "InjectionPressureAveragePsig",
    "InjectionPressureMaxPsig",
    "MaxDayInjLiqRate",
    "TotalGasVolumeMcf",
    "MaxDayInjGasRate",
    "AnnulusPressureNumReadings",
    "AnnulusPressureMinPsig",
    "AnnulusPressureMaxPsig",
    "CurrentInjectionIntervalTop",
    "CurrentInjectionIntervalBottom",
    "DepthTubingPacker",
    "FormationIds",
    "InjectedFluidsOtherSources",
    "InjectionThrough",
    "FractionSaltWater",
    "FractionFreshWater",
    "FractionFractureWaterFlowback",
    "FractionNorm",
    "FractionCo2",
    "FractionNaturalGas",
    "FractionH2s",
    "FractionPolymer",
    "FractionSteam",
    "FractionAir",
    "FractionNitrogen",
    "FractionOther",
    "OtherDesc"];

  @Input()
  public injectionBatch: InjectionDataBatch = null;

  public formationNamesById: any = {};

  constructor(
    public userWellService: UserWellsService
  ) { }

  ngOnInit(): void {
    this.userWellService.detailsWell.subscribe((x) => {
      if(x != null) {
        this.initFormations(x);
      }
    });
  }

  initFormations(wellRecord: WellDetailsModel) {

    if(wellRecord != null){
      let formationNamesById = {};

      for(let i=0; i < wellRecord.Formations.length; i++) {
        let formation = wellRecord.Formations[i];

        formationNamesById[formation.Id] = formation.Name;
      }

      this.formationNamesById = formationNamesById
    }
  }


}
